import { Environments } from 'src/types/Environments';

export default function getEnvironment(environment: string): Environments {
  switch (environment.toLowerCase()) {
    case 'prod':
      return Environments.prod;
    case 'gamma':
      return Environments.gamma;
    case 'beta':
      return Environments.beta;
    default:
      return Environments.beta;
  }
}
